<template>
    <div id="app-footer-pre" class="grey white--text">
        <v-layout wrap>
            <v-flex md6 lg4>
                <v-card outlined tile class="pa-2">
                    <span class="subtitle-1 font-weight-bold">대표 영업소:</span> <v-icon color="red">mdi-phone</v-icon> <span class="subtitle-1">(02) 3141 - 2345</span>
                </v-card>
            </v-flex>
            <v-flex md6 lg4>
                <v-card outlined tile class="pa-2">
                    <span class="subtitle-1 font-weight-bold">청주국제공항 영업소:</span> <v-icon color="red">mdi-phone</v-icon> <span class="subtitle-1">(043) 213-8090</span>
                </v-card>
            </v-flex>
            <v-flex md12 lg4>
                <v-card outlined tile class="pa-2">
                    <span class="subtitle-1 font-weight-bold">강서 영업소:</span> <v-icon color="red">mdi-phone</v-icon> <span class="subtitle-1"> (02) 2699-2340</span> | <v-icon color="red">mdi-web</v-icon> <span class="subtitle-1">vipclass.co.kr</span>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout id="app-footer-post">
            <v-col class="black white--text">
                <v-row class="justify-center">
                    VIP 리모렌터카: 서울특별시 중구 다산로 32, 남산타운 제 5상가 328호  |  고객 서비스：02-3141-2345  |  이메일: yhm@limokorea.co.kr
                </v-row>
                <v-row class="justify-center">
                    VIP 리모렌터카 Copyright reserved ©2019
                </v-row>
            </v-col>
        </v-layout>
    </div>
</template>

<script>
export default {
  name: "ContactMessageUs",

  data: () => ({})
};
</script>

<style scoped>
#app-footer-pre {
  /* margin-top: 80px; */
}
</style>
